// extracted by mini-css-extract-plugin
module.exports = {"container":"TabsLayout_container__3cQks","subPageContainer":"TabsLayout_subPageContainer__gaOvf"};